import React, { useEffect, useState } from 'react';
export const AudioWaveform: React.FC = () => {
  const [isActive, setIsActive] = useState(true);
  // Generate random heights for the waveform bars
  const generateHeights = () => {
    return Array.from({
      length: 40
    }, () => Math.floor(Math.random() * 30) + 5);
  };
  const [heights, setHeights] = useState(generateHeights());
  useEffect(() => {
    if (!isActive) return;
    const interval = setInterval(() => {
      setHeights(generateHeights());
    }, 150);
    return () => clearInterval(interval);
  }, [isActive]);
  return <div className="bg-background p-3 rounded-md" data-id="element-16">
      <div className="flex items-center mb-2" data-id="element-17">
        <div className="w-3 h-3 bg-orange-500 rounded-full mr-2 animate-pulse" data-id="element-18"></div>
        <span className="text-sm font-medium" data-id="element-19">Live Audio</span>
      </div>
      <div className="flex items-center justify-center h-12" data-id="element-20">
        <div className="flex items-end space-x-0.5" data-id="element-21">
          {heights.map((height, index) => <div key={index} className="w-1.5 bg-orange-500 rounded-full" style={{
          height: `${height}px`,
          opacity: height > 20 ? 1 : 0.6
        }} data-id="element-22"></div>)}
        </div>
      </div>
    </div>;
};